
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import ReviewCard from '@/components/review-card';
import { Review } from '@/lib/types';
import { ArrowRight } from 'lucide-react';

interface CompanyCardsListProps {
  companies: Review[];
  isShareFlow: boolean;
}

const CompanyCardsList = ({ companies, isShareFlow }: CompanyCardsListProps) => {
  const navigate = useNavigate();
  
  const handleAddReviewForCompany = (companyName: string) => {
    navigate(`/add-review?company=${encodeURIComponent(companyName)}`);
  };

  const handleViewCompanyProfile = (companyName: string) => {
    navigate(`/company/${encodeURIComponent(companyName)}`);
  };

  // Function to enhance ReviewCard with company info
  const renderReviewCardWithInfo = (item: Review) => {
    // Create enhanced review card with company info integrated in the card
    return (
      <div className="relative w-full">
        <ReviewCard 
          review={item} 
          hideTimeAgo={true}
          className="w-full" // Make the card full width
          layout="horizontal" // Use the horizontal layout for company cards
          disableCompanyLink={true} // Disable company name link
        />
        <div className="absolute top-6 right-6">
          <Button 
            onClick={() => handleViewCompanyProfile(item.company)}
            variant="destructive"
            size="sm"
            className="hover:bg-redflags-red/90"
          >
            View Profile
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 gap-6 animate-fade-in">
      {companies.map(item => (
        <div key={item.id} className="relative">
          {renderReviewCardWithInfo(item)}
          
          {/* Only show the Add Review button if we're in the share flow */}
          {isShareFlow && (
            <div className="mt-3 flex justify-center">
              <Button 
                onClick={() => handleAddReviewForCompany(item.company)}
                className="w-full bg-redflags-red hover:bg-redflags-red/90 text-white"
              >
                Share experience at {item.company}
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CompanyCardsList;
